import api from "../config/api";
import { DropDown } from "../types/DropDown";

const API_URL = "/dropDown";
export const getAllDropDowns = () =>
  api.get(`${API_URL}/`).then((res) => res.data.data);

export const getDropDownById = (id: number) => api.get(`${API_URL}/?id=${id}`);

export const createDropDown = (data: DropDown) => api.post(`${API_URL}/`, data);

export const updateDropDown = (id: number, data: DropDown) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const deleteDropDown = (id: number) =>
  api.delete(`${API_URL}/?id=${id}`);
